export default __webpack_public_path__ + "static/media/photo.8e2a7b96.png";